import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import ListItem from './ListItem';
import cssStyles from '../../../css/css-variables';
import { useViewport } from '../hooks/viewport';
import { ENABLE_SIDENAV_MENU } from '../constants';

const sharedStyled = css`
  ${!ENABLE_SIDENAV_MENU && 'padding: 0.833em 1.667em;'};
  text-family: Sofia Pro;
  text-size: ${!ENABLE_SIDENAV_MENU ? '18px' : '14px'};
  color: ${({isActiveLink}) => !ENABLE_SIDENAV_MENU ? '#000000' : isActiveLink ? '#414042' : cssStyles.colors.HoneyCreeper};
  ${!ENABLE_SIDENAV_MENU && 'line-height: 33px;'};
  text-align: left;
  &:hover{
    span{
      border-bottom: ${({isChild, isActiveLink}) => 
        ENABLE_SIDENAV_MENU && isActiveLink ? 
        `1px solid #414042` : 
        ENABLE_SIDENAV_MENU && !isActiveLink ? 
        `1px solid ${cssStyles.colors.HoneyCreeper}` : 
        isChild ? "1px solid #000000" : 
        "2px solid #FDB528"
      };
    }
  }

  li li & {
    padding: ${!ENABLE_SIDENAV_MENU ? '0.357em 3.214em' : '0.357em 0'};
  }

  text-decoration: none;
  ${({isChild}) => !isChild && `span{
    padding-left: 4px;
    padding-right: 4px;
  }`}

  ${({ isActiveLink }) => isActiveLink &&
    `
      background-color: ${cssStyles.colors.Background};
      margin-left: -2px;
      font-weight: 600;

      li li span {
        padding: 0.357em 3.214em;
        border-bottom: 1px solid #000000;
      }

      ${!ENABLE_SIDENAV_MENU && 
        `span{
          border-bottom: 2px solid #FDB528;
        }`
      }
      
      ul li li a:hover{
        border-bottom: ${!ENABLE_SIDENAV_MENU ? '1px solid #000000' : cssStyles.colors.HoneyCreeper};  
      } 

    `
  }
  ${({ isActiveLink }) => !isActiveLink &&
  `
    background-color: ${cssStyles.colors.Background};
    margin-left: -2px;
    color: ${!ENABLE_SIDENAV_MENU ? cssStyles.colors.NavText : cssStyles.colors.HoneyCreeper};
  `
}
  ${({ firstChild }) => firstChild && 'padding-top: 0.625em;'}
  ${({ lastChild }) => lastChild &&
    `
      border-top-width: 0;
    `
  }

  @media(max-width: 720px) {
    padding: 0;

    li li & {
      padding: 0 1.071em;
      border: none;
    }
  }
`;

export const StyledLink = styled(({ isActiveLink, onlyChild, firstChild, lastChild, isChild, ...props }) => <Link {...props} />)`${sharedStyled}`;
StyledLink.displayName = 'StyledLink';

const StyledBtn = styled.button`
  ${sharedStyled}
  background-color: transparent;
  color: ${cssStyles.colors.NavText};
  ${({isActiveButton}) => isActiveButton && ` 
    span{
    border-bottom: 2px solid #FDB528;
  }`} 
  text-family: Sofia Pro;
  text-size: 18px;
  border: none;
  ${({ isActiveButton, showChildren }) => (!showChildren && !isActiveButton) && `
      text-family: Sofia Pro;
      text-size: 18px;
      text-decoration: none solid rgb(0, 0, 0);
      border: none;
      color: ${cssStyles.colors.NavText};
  `}
`;
StyledBtn.displayName = 'StyledBtn';

let _clicked = false;

const MenuItem = props => {
  const { title, href, btnClick, children, isActive, location, isOpen, navToggle, icons, lastChild, firstChild, showChildren, isChild } = props;
  const { isMobile } = useViewport();
  const anchor = {
    onClick: (isOpen && isMobile && href) ? navToggle : null
  };

  let icon = (isActive || showChildren) ? icons.activeIcon || null : icons.inactiveIcon || null;
  icon = (React.Children.count(children)) ? icon : null;
  const currentPath = (location && location.pathname) || '';
  const qaHook = props['data-qa-hook'] ? { 'data-qa-hook': props['data-qa-hook'] } : null;

  // remedies form fields stealing menu focus
  const focusCheck = (e) => {
    if (e.target !== document.activeElement) {
      if (_clicked) e.target.click();
    }
    _clicked = false;
  };

  // helps correct click-stealing by forms
  const prepareClick = () => {
    _clicked = true;
  };
  return (
    <ListItem firstChild={firstChild} isActive={isActive} isMenu>
      {btnClick ?
        <StyledBtn
          onClick={btnClick}
          isActiveButton={isActive}
          onMouseDown={prepareClick}
          onMouseUp={focusCheck}
          lastChild={lastChild}
          showChildren={showChildren}
          {...qaHook}
        >
          <span>{title}</span>{icon}
        </StyledBtn>
        :
        <StyledLink
          to={href || `${currentPath}#`}
          isActiveLink={isActive}
          onMouseDown={prepareClick}
          onMouseUp={focusCheck}
          lastChild={lastChild}
          isChild={isChild}
          {...anchor}
          {...qaHook}
        >
          <span>{title}</span>{icon}
        </StyledLink>
      }
      {children}
    </ListItem>
  );
};

const { bool, node, string, object, func, shape } = PropTypes;

MenuItem.propTypes = {
  title: string.isRequired,
  href: string,
  children: node,
  isActive: bool,
  isOpen: bool,
  navToggle: func,
  location: object.isRequired,
  icons: shape({
    iconActive: node,
    iconInactive: node
  })
};

export default MenuItem;
